import axios from 'axios'
const API_URL = process.env.REACT_APP_API_URL

export function getRolesList() {
  return axios.get(API_URL+'/v1/rol/list')
}
export function getRolesListglobal(tenant:number) {
  return axios.get(API_URL+'/v1/rol/list?tenantId='+tenant)
}
export function getpermisosDisponibles() {
  return axios.get(API_URL+'/v1/permission')
}
export function getpermisosDisponiblesGlobal(tenant:number) {
  return axios.get(API_URL+'/v1/permission?tenantId='+tenant)
}
export function getPermisoId(id:any) {
    return axios.get(API_URL+'/v1/rol/'+id)
  }
export function getPermisoIdGlobal(id:any,tenant:number) {
    return axios.get(API_URL+'/v1/rol/'+id+'?tenantId='+tenant)
  }
export function getroles() {
    return axios.get(API_URL+'/v1/rol/')
  }